export const isValidCpf = (cpf: string): boolean => cpf.length === 11;
